import documentInsert from '../../lib/documentInsert'
import documentUpdate from '../../lib/documentUpdate'
import documentRemove from '../../lib/documentRemove'
import generateThumb from '../../lib/generateThumb'

import * as timecode from '../../../../lib/timecode'

export function getName(){
  return 'archive/marker'
}

var tagsById

export function getTableColumns(o,item){

  var lang = o.store('lang')

  if(tagsById[item.tag]){
    var tag = tagsById[item.tag][0][lang]
  } else {
    var tag = null
  }

  var columns = [
    {
      id: 'roll',
      value: item.roll,
      type: o.type.text,
    },
    {
      id: 'start',
      value: item.start,
      type: o.type.timecode,
    },
    {
      id: 'tag',
      value: tag,
      type: o.type.text,
    },
    {
      id: 'notes',
      value: item.notes,
      type: o.type.textLong,
      width: 300,
      multiline: true,
      auth: ['admin','author'],
    },
    {
      id: 'user',
      value: item.user,
      type: o.type.text,
      auth: ['admin','author'],
    },
    {
      id: 'date',
      value: item.date,
      type: o.type.date,
      auth: ['admin','author'],
    },
  ]

  return columns

}

export function getTableData(o){

  tagsById = _.groupBy(o.data.archive.tags,'_id')

  var data =
    _.map(

      o.data.archive.markers,

      function(item){

        var model = o.model.aMarkers
        var columns = model.getTableColumns(o,item)

        var click =
          function(){
            var roll = _.find(o.data.rolls, {roll: item.roll})
            var start = timecode.toSeconds(item.start)
            o.player.load(roll,start)
            o.edit.set(item,model)
          }

        return {
          columns: columns,
          click: click,
        }

      }
    )

  return data

}

export function getFormFields(o,item){

  var lang = o.store('lang')

  if(!item){
    var item = {}
  }

  if(o.loopStart){
    var start = timecode.toSmtp(o.loopStart)
  } else {
    var start = timecode.toSmtp(0)
  }

  var init = {
    roll: o.roll,
    start: start,
    public: false,
  }

  var fields = [
    {
      id: 'roll',
      value: item.roll,
      type: 'text',
      init: init.roll,
    },
    {
      id: 'start',
      value: item.start,
      type: 'timecode',
      edit: true,
      init: init.start,
    },
    {
      id: 'tag',
      value: item.tag ? _.find(o.data.archive.tags,{_id: item.tag})[lang] : null,
      type: 'text',
      options: _.map(o.data.archive.tags, lang),
      optionsModel: o.model.aTags,
      edit: true,
    },
    {
      id: 'notes',
      value: item.notes,
      type: 'textLong',
      optional: true,
      edit: true,
    },

  ]

  return fields

}

export function insertForm(o,done){

}

export function remove(o,id,done){

  var data = o.data.archive.markers
  var collection = 'a_markers'

  documentRemove(o,data,id,collection,done)

}

export function insert(o,item,done){

  var lang = o.store('lang')

  var data = o.data.archive.markers
  var collection = 'a_markers'

  if(item.tag){
    var tag = _.find(o.data.archive.tags,{[lang]: item.tag})
    if(tag){
      item.tag = tag._id
    }
  }

  var d = function(error,item){
    o.player.updateMarkers()
    done(error,item)
  }

  item.user = o.store('email')
  item.date = new Date()

  documentInsert(o,data,item,collection,d)
  generateThumb(item.roll,item.start)

}

export function update(o,id,changes,done){

  var lang = o.store('lang')

  var data = o.data.archive.markers
  var collection = 'a_markers'

  var startChange = _.find(changes,{id: 'start'})

  if(startChange){
    var marker = _.find(data,{_id: id})
    var roll = marker.roll
    var start = startChange.value
    generateThumb(roll,start,marker.start)
  }

  var tagChange = _.find(changes,{id: 'tag'})

  if(tagChange){
    var value = tagChange.value
    var tag = _.find(o.data.archive.tags,{[lang]: value})
    if(tag){
      tagChange.value = tag._id
    }
  }

  changes.push({
    id: 'user',
    value: o.store('email'),
  })

  changes.push({
    id: 'date',
    value: new Date(),
  })

  documentUpdate(o,data,id,changes,collection,done)

}



// WEBPACK FOOTER //
// ./src/client/view/admin/model/aMarkers/aMarkers.js